
import { Options, Vue } from "vue-class-component"; //基本需要\
import * as echarts from "echarts";
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import {
  dispatchGetTOPReportTableList,
  dispatchGetTOPReportTable,
  dispatchSendTOPReport,
  dispatchUpdateTOPReport,
  dispatchGetTOPReport,
  dispatchGetTOPReportDetail,
  dispatchGetTOPReportList,
  dispatchGetTOPReportGenerate,
  dispatchDeleteTOPReport,
  dispatchClearCache,
} from "@/store/performance/actions";
import { store } from "@/store";
import { dateConversion, getCurrentTime, getLocalProject } from "@/utils";
import {
  readTOPReport,
  readTOPReportDetail,
  readTOPReportList,
  readTOPReportTable,
  readTOPReportTableList,
} from "@/store/performance/getters";
import { readMyProjects, readProjectDetail } from "@/store/project/getters";
import { ITOPReportTable, IUploadReportSimple } from "@/interfaces";
import { readUserProfile } from "@/store/main/getters";

@Options({
  components: {
    SideMenu,
  },
})
export default class TestReport extends Vue {
  public get testSummary() {
    return [
      { label: this.top_report.risk, value: "版本TOP性能风险级别" },
      {
        label: String(this.top_report.base_info.test_model_num),
        value: "测试机型总数",
      },
      {
        label: String(this.top_report.base_info.pass_model_num),
        value: "通过机型个数",
      },
      {
        label: String(this.top_report.base_info.no_pass_model_num),
        value: "不通过机型个数",
      },
      { label: this.top_report.base_info.pass_rate, value: "通过率" },
    ];
  }
  // 任务报告table
  public columns = [
    { prop: "id", label: "序号", align: "center", width: 70 },
    { prop: "timestamp", label: "测试时间", width: 175 },
    { prop: "task_record_id.create_user", label: "测试人员", width: 100 },
    { prop: "device_id.model.name", label: "设备信息" },
    { prop: "project.pkg_name", label: "游戏包名" },
    { prop: "scene_id.chinese", label: "地图名" },
    { prop: "game_version", label: "游戏版本" },
    { prop: "task_record_id.id", label: "record", width: 85 },
    { prop: "avg_fps", label: "FPS", width: 75 },
    { prop: "max_pss", label: "pss", width: 60 },
    { prop: "avg_cpu", label: "cpu", width: 60 },
  ];

  // form 下拉框数据
  public resBase64: any[] = []; // 趋势图存储
  public dialogFormVisible1 = false;
  public project_search = "";
  public testName_search = "";
  public date_search: string[] = [];
  public async change_name_search1(type: any) {
    if (type === "userName") {
      this.loading = true;

      await dispatchGetTOPReportTable(store, {
        project: this.localProject,
        sub_project: this.project_search,
        date: this.date_search,
        user: this.testName_search,
      });
      this.tableAll();
      this.tableTotal = this.top_report_table.length;
      this.loading = false;
    }
    if (type === "project") {
      this.loading = true;

      await dispatchGetTOPReportTable(store, {
        project: this.localProject,
        sub_project: this.project_search,
        date: this.date_search,
        user: this.testName_search,
      });
      this.tableAll();
      this.tableTotal = this.top_report_table.length;
      this.loading = false;
    }
    if (type === "dateTime") {
      this.loading = true;

      await dispatchGetTOPReportTable(store, {
        project: this.localProject,
        sub_project: this.project_search,
        date: this.date_search,
        user: this.testName_search,
      });
      this.tableAll();
      this.tableTotal = this.top_report_table.length;
      this.loading = false;
    }
    (this.$refs as any).tb.clearSelection();
  }
  // 公共数组table
  public top_report_table: any = [];
  public tableAll() {
    this.top_report_table = readTOPReportTable(store);
    this.top_report_table.forEach((v: any) => {
      v.timestamp = dateConversion(v.timestamp);
    });
  }
  // 邮件
  public edit = false;
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  // 编辑报告表单
  public reportForm = {
    name: "",
  };
  // 生成报告公共数据

  public report_name = "";
  public project1 = 0;
  public sub_project = 0;
  public performance_id_list: any = [];
  // 翻页数据
  public tableTotal = 0;
  // 点击发送
  public sendOut() {
    this.edit = !this.edit;
  }
  public handleSelect(val: any) {
    this.performance_id_list = val.map((item: ITOPReportTable) => item.id);
  }

  public get tableHead() {
    let data = [
      "序号",
      "机型",
      "档位",
      "benchmark评分",
      "影响用户  (%)",
      "指标",
    ];
    this.top_report.base_info.scene_list.forEach((item) => data.push(item));
    data.push("风险等级");
    return data;
  }
  public currentPage = 1; // 当前页码
  public pageSize = 20; // 每页显示的行数
  public loading = false;
  public taskReport = false;
  public async clear() {
    this.loading = true;
    await dispatchClearCache(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
    });
    // await dispatchGetTOPReportDetail(store, {
    //   project: this.localProject,
    //   id: Number(this.report_id),
    // });
    //调用获取性能报告接口
    await dispatchGetTOPReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
    });

    this.resBase64 = [];
    await this.drawLine();
    this.loading = false;
  }
  // 项目列表
  public get projectList() {
    return readTOPReportTableList(store).project_list;
  }
  public get testNameList() {
    return readTOPReportTableList(store).user_list;
  }
  public get dateList() {
    return readTOPReportTableList(store).date_list;
  }
  public generateReportsManually() {
    this.taskReport = !this.taskReport;
  }

  public handleCurrentChange(val: any) {
    this.currentPage = val;
  }

  //获取报告名称的列表
  public get report_list() {
    let name_list: any[] = [];
    name_list = readTOPReportList(store);
    return name_list;
  }
  public dialogTableVisible = false;

  drawLine() {
    // 基于准备好的dom，初始化echarts实例
    var chartDom = document.getElementById("myChart") as HTMLElement;
    var myChart = echarts.init(chartDom);
    // 绘制图表
    let series: any[] = [];
    this.top_report.trend.series.forEach((item) => {
      series.push({
        name: item.name,
        type: "line",
        symbol: "circle", //拐点设置为实心
        data: item.pass_rate,
      });
    });
    myChart.setOption({
      title: {
        text: this.top_report.project_name + "-TOP机型性能通过率趋势图",
        x: "center",
        y: "top",
        textAlign: "left",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        orient: "horizontal",
        left: "center",
        top: " 420px",
        data: this.top_report.trend.levels,
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "13%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      animation: false,
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.top_report.trend.versions,
      },
      yAxis: {
        type: "value",
        offset: 10,
        axisLabel: {
          formatter: "{value}",
        },
        scale: true,
        max: function (value: any) {
          return Math.ceil(value.max * 1.1);
        },
        min: function (value: any) {
          return Math.ceil(value.min * 0.9);
        },
      },
      series: series,
    });
    var res_base64 = myChart.getDataURL({
      excludeComponents: ["toolbox"],
    }); //拿到base64 地址，就好下载了。
    let res: any = {};
    res.file_base64 = res_base64;
    res.filename = "pass_rate_trend.png";
    this.resBase64.push(res);
  }
  public localProject = Number(getLocalProject()); //得到本地的项目
  public report_id = 0; //得到本地的项目

  public async mounted() {
    this.loading = true;
    await dispatchGetTOPReportList(store, { project: this.localProject });
    if (this.$route.query.project) {
      this.localProject = Number(this.$route.query.project);
    }
    if (this.$route.query.report_id) {
      this.report_id = Number(this.$route.query.report_id);
    } else {
      this.report_id = readTOPReportList(store)[0]?.id;
      this.$router.push({
        query: { ...this.$route.query, report_id: this.report_id },
      });
    }

    await dispatchGetTOPReportTableList(store, { project: this.localProject });
    this.date_search = [readTOPReportTableList(store).date_list[0]];
    await dispatchGetTOPReportTable(store, {
      project: this.localProject,
      sub_project: "",
      date: this.date_search,
      user: "",
    });

    dispatchGetTOPReportDetail(store, {
      project: this.localProject,
      id: this.report_id,
    });
    await dispatchGetTOPReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await this.addressee; //解析邮件收件人
    this.resBase64 = [];
    await this.drawLine();

    let risk = document.getElementById("版本TOP性能风险级别");

    if (risk?.firstChild?.textContent === "高风险") {
      (risk.firstChild as any).style.color = "red";
    } else if (risk?.firstChild?.textContent === "中风险") {
      (risk.firstChild as any).style.color = "#cd950c";
    } else if (risk?.firstChild?.textContent === "低风险") {
      (risk.firstChild as any).style.color = "#00b050";
    }
    // this.top_report_table
    await this.top_report_table_list;
    await this.tableAll();

    this.loading = false;
  }

  // 删除报告
  public async handleDelete() {
    await dispatchDeleteTOPReport(store, {
      id: this.report_id,
      project: this.localProject,
    });
    this.loading = true;
    await dispatchGetTOPReportList(store, { project: this.localProject });
    this.report_id = readTOPReportList(store)[0]?.id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    dispatchGetTOPReportDetail(store, {
      project: this.localProject,
      id: this.report_id,
    });
    await dispatchGetTOPReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await this.addressee; //解析邮件收件人
    this.resBase64 = [];
    await this.drawLine();

    // this.top_report_table
    await this.top_report_table_list;
    await this.tableAll();

    this.loading = false;
  }

  // 生成报告
  public async generateReportbtn() {
    await dispatchGetTOPReportGenerate(store, {
      report_name: "【TOP性能测试报告】-" + getCurrentTime(),
      project: this.localProject,
      sub_project: Number(this.project_search),
      performance_id_list: this.performance_id_list,
    });
    this.dialogTableVisible = false;
    this.loading = true;
    await dispatchGetTOPReportList(store, { project: this.localProject });
    this.report_id = readTOPReportList(store)[0]?.id;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });
    dispatchGetTOPReportDetail(store, {
      project: this.localProject,
      id: this.report_id,
    });
    await dispatchGetTOPReport(store, {
      project: this.localProject,
      report_id: this.report_id,
    });
    await this.addressee; //解析邮件收件人
    this.resBase64 = [];
    await this.drawLine();

    // this.top_report_table
    await this.top_report_table_list;
    await this.tableAll();

    this.loading = false;
  }
  // 报告数据
  public get top_report() {
    return readTOPReport(store);
  }
  public get top_report_table_list() {
    return readTOPReportTableList(store);
  }
  // 报告信息
  public get top_report_info() {
    let report = readTOPReportDetail(store);
    report.create_date = dateConversion(report.create_date);
    return report;
  }
  // 判断是否是管理员
  public get get_is_super() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }
  // public get top_report_table(){
  //   let reportTable  = readTOPReportTable(store)

  //  reportTable.forEach(function(v){
  //    v.timestamp=dateConversion(v.timestamp)

  //  })

  //   console.log(reportTable)
  //   return reportTable
  // }

  // 报告名称切换时
  public async report_change() {
    this.loading = true;
    this.$router.push({
      query: { ...this.$route.query, report_id: this.report_id },
    });

    // 邮件收件人
    // 获取当前报告数据
    await dispatchGetTOPReportDetail(store, {
      project: this.localProject,
      id: Number(this.report_id),
    });
    //调用获取性能报告接口
    await dispatchGetTOPReport(store, {
      project: this.localProject,
      report_id: Number(this.report_id),
    });

    this.resBase64 = [];
    await this.drawLine();
    this.loading = false;
  }

  public getRowKeys(row: any) {
    return row.id;
  }

  public get project() {
    return readProjectDetail(store);
  }
  // public change_name_search1(type: any) {
  //   if (type === "project") {
  //     console.log(this.project_search);
  //     this.sub_project = Number(this.project_search);
  //     this.top_report_table = readTOPReportTable(store).filter(
  //       (v) => v.project.id === Number(this.project_search)
  //     );
  //     this.date_search = "";
  //     this.testName_search = "";
  //   } else if (type === "userName") {
  //     this.top_report_table = readTOPReportTable(store).filter(
  //       (v) => v.task_record_id.create_user === this.testName_search || v.tester === this.testName_search
  //     );
  //     this.project_search = "";
  //     this.date_search = "";
  //   } else {
  //     this.top_report_table = readTOPReportTable(store).filter(
  //       (v) => v.timestamp.split(" ")[0] === this.date_search
  //     );
  //     this.project_search = "";
  //     this.testName_search = "";
  //   }
  // }

  // 全部清空
  public async clearAll() {
    (this.date_search = [readTOPReportTableList(store).date_list[0]]),
      (this.testName_search = "");
    this.project_search = "";
    await dispatchGetTOPReportTable(store, {
      project: this.localProject,
      sub_project: "",
      date: this.date_search,
      user: "",
    });
    this.tableAll();
  }
  // 解析邮件收件人
  public get addressee() {
    let addressee = this.project?.report_settings
      ? JSON.parse(
          this.project.report_settings as any
        ).notify.email.receiver.join(";")
      : "";
    this.formMail.title = this.top_report_info.report_name;
    this.formMail.addressee = addressee;
    this.formMail.addressee = addressee;
    return addressee;
  }

  //发送报告
  public save_report() {
    let upload_data: IUploadReportSimple;
    upload_data = {
      project: this.localProject,
      report_id: this.report_id,
      file_list: this.resBase64,
      title: this.formMail.title,
      recv: this.formMail.addressee,
      cc: this.formMail.CC_List,
      send: this.formMail.Sender,
    };
    dispatchSendTOPReport(store, upload_data);
    this.edit = false;
  }

  // 编辑报告
  public handleEdit() {
    this.dialogFormVisible1 = true;
    this.reportForm.name = this.top_report_info.report_name;
  }

  // 编辑报告调用接口
  public async dialogFormVisible2() {
    this.dialogFormVisible1 = false;
    await dispatchUpdateTOPReport(store, {
      project: this.localProject,
      id: Number(this.report_id),
      report_name: String(this.reportForm.name),
      creator: this.top_report_info.creator,
    });
    dispatchGetTOPReportList(store, { project: this.localProject });
  }
}
